import { render, staticRenderFns } from "./selectArea.vue?vue&type=template&id=1a9e32ef&scoped=true&"
import script from "./selectArea.vue?vue&type=script&lang=js&"
export * from "./selectArea.vue?vue&type=script&lang=js&"
import style0 from "./selectArea.vue?vue&type=style&index=0&id=1a9e32ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e32ef",
  null
  
)

export default component.exports